module.exports = __webpack_public_path__ + "static/media/down-arrow.2aae27bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/down-arrow.svg
// module id = 793
// module chunks = 0